<template>
  <transition name="fade">
    <div
      v-if="show"
      :class="`${status} ${status}--text`"
      class="d-flex align-center justify-center snack-bar"
    >
      {{ message }}
      <pp-button
        absolute
        bottom
        icon="close"
        right
        type="icon"
        class="snack-bar__close"
        @click="show = false"
      />
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SnackBar',
  data () {
    return {
      message: null,
      show: false,
      status: null,
      duration: null
    }
  },
  computed: {
    ...mapGetters({
      snackMessage: 'ui/snackMessage'
    })
  },
  watch: {
    snackMessage ({ message, status, duration }) {
      this.message = message || 'Error'
      this.show = true
      this.status = status || 'error'
      this.duration = duration || 3500

      setTimeout(() => { this.show = false }, this.duration)
    }
  }
}
</script>
<style lang="scss" scoped>
.snack-bar {
  bottom: 0;
  min-height: 2.5em;
  position: absolute;
  text-align: center;
  width: 100%;

  &__close {
    ::v-deep {
      .v-btn {
        bottom: 0;
      }
    }
  }
}
</style>
